import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../context/LanguageContext';
import Sidebar from './Sidebar';
import { FaBars, FaTimes } from 'react-icons/fa';

const Layout = ({ children }) => {
    const { isRTL } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1280);

    useEffect(() => {
        const checkScreenSize = () => {
            const isDesktopSize = window.innerWidth >= 1280; // xl breakpoint - treat iPad as mobile
            setIsDesktop(isDesktopSize);
            if (isDesktopSize) {
                setIsSidebarOpen(false); // Reset sidebar state on desktop
            } else {
                // Ensure sidebar is closed on smaller screens by default
                setIsSidebarOpen(false);
            }
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className="flex min-h-screen bg-gray-100 relative">
            {/* Mobile/Tablet Hamburger Menu */}
            {!isDesktop && (
                <button
                    onClick={toggleSidebar}
                    className={`fixed top-4 ${isRTL ? 'right-4' : 'left-4'} z-50 xl:hidden bg-yellow-500 text-white p-3 rounded-lg shadow-lg hover:bg-yellow-600 transition-all duration-200`}
                >
                    {isSidebarOpen ? <FaTimes className="w-5 h-5" /> : <FaBars className="w-5 h-5" />}
                </button>
            )}

            {/* Mobile/Tablet Overlay */}
            {!isDesktop && isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-30 xl:hidden"
                    onClick={toggleSidebar}
                />
            )}

            {/* Sidebar */}
            <div className={`
                fixed inset-y-0 ${isRTL ? 'right-0' : 'left-0'} w-64 z-40 transition-transform duration-300 ease-in-out
                ${
                    isDesktop 
                        ? 'translate-x-0' 
                        : isSidebarOpen 
                            ? 'translate-x-0' 
                            : isRTL 
                                ? 'translate-x-full' 
                                : '-translate-x-full'
                }
            `}>
                <Sidebar onClose={!isDesktop ? toggleSidebar : undefined} />
            </div>

            {/* Main Content */}
            <main className={`
                flex-1 transition-all duration-300 ease-in-out min-w-0 w-full overflow-y-auto
                ${
                    isDesktop 
                        ? isRTL ? 'mr-64' : 'ml-64'
                        : ''
                }
                ${
                    !isDesktop ? 'p-2 sm:p-4 pt-20' : 'p-8'
                }
            `}>
                <div className={isRTL ? 'text-right' : 'text-left'}>
                    {children}
                </div>
            </main>
        </div>
    );
};

export default Layout;
